import Vue from 'vue'
import dm from 'kkt-domain'

// use
Vue.use(dm)

/*
* 注册全局时间过滤器
 */
Vue.filter('dateFilter', function (val) {
  if (val) {
    return val.split('-').splice(1).join('/')
  } else {
    return null
  }
})



// WEBPACK FOOTER //
// ./src/utils/index.js